(function () {
  const SELECTOR = '[data-option="one-time-purchase"]';
  const RETRY_MS = 500;
  const MAX_WAIT_MS = 15000;
  const DEBUG = false; // flip to true to restore logging

  const log = DEBUG ? (...a) => console.log('[default-purchase-option]', ...a) : () => {};

  const start = Date.now();
  let baselineClass = null;
  let done = false;

  const intervalId = setInterval(() => {
    if (done) return; // extra safety, shouldn't be reachable

    const el = document.querySelector(SELECTOR);
    const timedOut = Date.now() - start >= MAX_WAIT_MS;

    if (!el) {
      log('not found yet');
      if (timedOut) { clearInterval(intervalId); log('gave up, element never appeared'); }
      return;
    }

    if (baselineClass === null) baselineClass = el.className; // capture once, first time we see it

    if (el.className !== baselineClass) {
      log('selected:', el.className);
      done = true;
      clearInterval(intervalId);
      return;
    }

    if (timedOut) {
      clearInterval(intervalId);
      log('gave up, click never changed state');
      return;
    }

    el.click();
    log('clicked, awaiting state change');
  }, RETRY_MS);

  // Replo's frequency dropdown sits inside the Subscribe tile but stops its click
  // from reaching the selection list, so picking a frequency while One-time is
  // selected switches the cart to a subscription and leaves the One-time radio on.
  // Select the Subscribe tile to match, then put the chosen frequency back,
  // because the tile's own click action resets it to the first plan.
  const SUB_SELECTOR = '[data-option="subscribe-and-save"]';

  // Replo renders each option's radio after it, valued "<data-rid>.<n>".
  const isSelected = (option) => {
    const rid = option.getAttribute('data-rid');
    const radio = rid && [...option.parentElement.querySelectorAll('input[type="radio"]')]
      .find((r) => r.value.startsWith(rid + '.'));
    return !!(radio && radio.checked);
  };

  document.addEventListener('change', (e) => {
    const select = e.target;
    if (!(select instanceof HTMLSelectElement)) return;
    const sub = select.closest(SUB_SELECTOR);
    if (!sub || isSelected(sub)) return;

    const planId = select.value;
    const rid = sub.getAttribute('data-rid');
    sub.click();
    log('frequency changed while One-time selected; selected Subscribe');

    // Wait for Replo to apply the click, which resets the plan in the same render.
    const restoreStart = Date.now();
    const restore = setInterval(() => {
      const tile = sub.isConnected ? sub : document.querySelector(`[data-rid="${rid}"]`);
      const current = tile && tile.querySelector('select');
      if (!current || Date.now() - restoreStart >= 1000) { clearInterval(restore); return; }
      if (!isSelected(tile)) return;
      clearInterval(restore);
      if (current.value === planId) return;
      current.value = planId;
      current.dispatchEvent(new Event('change', { bubbles: true }));
      log('restored frequency', planId);
    }, 50);
  });
})();